import { useEffect, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Tab, Tabs } from '@mui/material';
import TenantPage from 'components/common/TenantPage';
import {
  ORDER_LINE_STATUS_TABS,
  normalizeOrderLineStatusTab,
  orderLineStatusFilterForTab,
  OrderLineStatusTab
} from '../../../../constants';
import { OrderLinesStatusGrid } from './OrderLinesStatusGrid';

export function DeliveryExpected() {
  const translationPrefix = 'pages.orders.order_lines';
  const { t } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();

  const orderRef = searchParams.get('ref');
  const activeTab = useMemo(() => {
    if (searchParams.get('blameMode')) {
      return ORDER_LINE_STATUS_TABS.IN_ARRIVO;
    }
    return normalizeOrderLineStatusTab(searchParams.get('tab'));
  }, [searchParams]);

  useEffect(() => {
    if (!searchParams.get('blameMode')) {
      return;
    }
    const next = new URLSearchParams(searchParams);
    next.delete('blameMode');
    next.set('tab', ORDER_LINE_STATUS_TABS.IN_ARRIVO);
    setSearchParams(next, { replace: true });
  }, [searchParams, setSearchParams]);

  const handleTabChange = (_event: React.SyntheticEvent, newTab: OrderLineStatusTab) => {
    const next = new URLSearchParams(searchParams);
    next.set('tab', newTab);
    next.delete('blameMode');
    setSearchParams(next);
  };

  const statusFilter = orderLineStatusFilterForTab(activeTab);

  return (
    <TenantPage
      title={t(`${translationPrefix}.title`)}
      subtitle={t(`${translationPrefix}.subtitle`)}
      menuRight={<div></div>}>
      <Tabs
        value={activeTab}
        onChange={handleTabChange}
        textColor="secondary"
        indicatorColor="secondary"
        sx={{ mb: 2 }}>
        <Tab
          value={ORDER_LINE_STATUS_TABS.IN_ARRIVO}
          label={t(`${translationPrefix}.tab_in_arrivo`)}
        />
        {/*
        <Tab
          value={ORDER_LINE_STATUS_TABS.AWAITING_CONFIRMATION}
          label={t(`${translationPrefix}.tab_awaiting_confirmation`)}
        />
        */}
      </Tabs>
      <OrderLinesStatusGrid key={activeTab} statusFilter={statusFilter} orderRef={orderRef} />
    </TenantPage>
  );
}

export default DeliveryExpected;
